/**
 * Dizionario it.
 *
 * Italiano: la lingua di partenza. Le altre sono traduzioni di questo albero.
 *
 * Le chiavi devono essere identiche a quelle di `it`: il test
 * `backend/tests/test_jurisdictions.py::test_le_lingue_dichiarate_sono_quelle_tradotte`
 * confronta i file di questa cartella con `APP_LOCALES`, e
 * `test_b2b_frontend_wiring.py` controlla che ogni chiave usata da un pannello
 * esista in **ogni** lingua. Aggiungere una lingua è quindi un file nuovo qui
 * più il codice in `APP_LOCALES`, non una modifica a `i18n.jsx`.
 */
export default {
  "nav": {
    "showcase": "Vetrina",
    "directory": "Strutture",
    "network": "Rete",
    "pricing": "Tariffe",
    "login": "Accedi",
    "signup": "Iscrivi struttura",
    "dashboard": "Dashboard",
    "logout": "Esci",
    "book": "Prenota",
    "host_area": "Gestisco una struttura",
    "find_stay": "Trova alloggio",
    "bedbank": "Bedbank",
    "claim": "Rivendica",
    "affiliates": "Affiliati",
    "merchant_area": "Area commerciante",
    "merchants": "Commercianti",
    "merchant_login": "Accesso commercianti",
    "merchant_login_title": "Sono un'attività locale",
    "merchant_space": "Spazio commercianti",
    "host_dashboard": "Dashboard host",
    "account": "Account",
    "language": "Lingua"
  },
  "landing": {
    "eyebrow": "Piattaforma per strutture ricettive",
    "title1": "Ospitalità italiana,",
    "title2": "nel mondo.",
    "subtitle": "Promuovi la tua struttura, sincronizza le OTA, scambia camere con partner fidati. Una casa digitale per B&B, agriturismi e hotel.",
    "cta_primary": "Inizia gratis",
    "cta_secondary": "Guarda le vetrine",
    "f1_title": "Vetrina in sette lingue",
    "f1_body": "Una pagina pubblica in italiano, inglese, spagnolo, francese, tedesco, portoghese e greco che racconta la tua struttura. Foto, camere, prenotazione diretta con Stripe.",
    "f2_title": "Rete tra strutture",
    "f2_body": "Sei overbooked? Gira il cliente a un partner. Marketplace nazionale + gruppi chiusi locali.",
    "f3_title": "Richieste di gruppo",
    "f3_body": "Pubblica una richiesta di gruppo numeroso, le strutture vicine rispondono. Colazione centralizzata inclusa.",
    "f4_title": "Calendario unico",
    "f4_body": "Prenotazioni dirette, camere in rete, OTA sincronizzate via iCal (in arrivo). Zero overbooking.",
    "f5_title": "PMS incluso",
    "f5_body": "Un vero Property Management System dentro la piattaforma: front office, reception, pulizie, cucina, acquisti e registro operazioni. Nessun software extra da pagare.",
    "showcase_title": "Strutture in vetrina",
    "showcase_sub": "Alcune delle case che si raccontano su Hostaly.",
    "how_title": "Come funziona",
    "how_1": "Iscrivi la tua struttura",
    "how_1b": "Registrazione in 60 secondi. Verifica automatica per l'MVP.",
    "how_2": "Configura la vetrina in sette lingue",
    "how_2b": "Testi per ogni lingua, foto, servizi, camere. Pubblica quando sei pronta.",
    "how_3": "Entra nella rete",
    "how_3b": "Offri camere last-minute, rispondi a richieste di gruppo, ricevi pagamenti.",
    "final_title": "La casa digitale delle strutture ricettive",
    "final_body": "Un'unica piattaforma per gestire vetrina, rete e prenotazioni."
  },
  "auth": {
    "login": "Accedi",
    "register": "Iscrivi la tua struttura",
    "email": "Email",
    "password": "Password",
    "structure": "Nome struttura",
    "country": "Paese della struttura",
    "country_help": "Decide gli obblighi che ti riguardano. Non è la lingua dell'interfaccia: quella la scegli a parte.",
    "cin_label": "Codice CIN",
    "cin_help": "Codice Identificativo Nazionale MITUR — obbligatorio per legge (DL 145/2023). Formato nazionale: IT + 15 caratteri (17 totali). Alcune regioni come Sicilia possono usare formati più lunghi (fino a 22 caratteri). Richiedilo su bdsr.ministeroturismo.gov.it",
    "cin_not_required": "Fuori dall'Italia il CIN non serve: ti chiederemo il numero di registrazione locale quando sarà il momento.",
    "submit_login": "Entra",
    "submit_register": "Crea account",
    "aff_rules": "Regole di affiliazione",
    "aff_consent": "Dichiaro di aver letto e accettato le",
    "aff_consent_hint": "Obbligatorio per iscrivere la struttura: comprende commissioni, pagamenti, obblighi della struttura e tutte le promozioni previste dal contratto (clausola 6.4).",
    "switch_to_register": "Non hai un account? Iscrivi la struttura",
    "switch_to_login": "Hai già un account? Accedi",
    "forgot": "Password dimenticata?",
    "demo_hint": "Demo: demo@hospitalityhub.it / demo1234",
    "staff_title": "Crea il tuo account",
    "staff_hint": "Il titolare della struttura ti ha assegnato un ruolo. Usa esattamente l'indirizzo email con cui te l'ha assegnato: è quello che collega il tuo account al ruolo.",
    "staff_name": "Nome e cognome",
    "staff_name_help": "Facoltativo. Serve solo perché i tuoi colleghi ti riconoscano.",
    "role_label": "Il tuo ruolo nella struttura",
    "role_general_manager": "General Manager (proprietario)",
    "role_operations_manager": "Operations Manager",
    "role_manager": "Manager",
    "role_operator": "Operatore (pulizie/cucina/riparazioni)",
    "role_help": "Determina cosa puoi fare in Gestione Hotel. Il General Manager può gestire i ruoli dello staff.",
    "staff_password_hint": "Almeno 8 caratteri.",
    "staff_submit": "Crea il mio account",
    "account_created": "Account creato",
    "welcome_back": "Bentornata/o",
    "cin_invalid": "Codice CIN non valido. Deve iniziare con 'IT' seguito da 14-20 caratteri alfanumerici.",
    "cin_title": "Inizia con IT + 14-20 caratteri (16-22 totali, es. Sicilia 18)",
    "aff_required": "Devi prendere visione delle Regole di affiliazione per procedere.",
    "google": "Continua con Google",
    "apple": "Continua con Apple",
    "soon": "presto",
    "google_unavailable": "Login Google non disponibile",
    "google_not_configured": "Accesso con Google non configurato su questa installazione. Usa email e password; la chiave (GOOGLE_CLIENT_ID / GOOGLE_CLIENT_SECRET) va aggiunta sul server.",
    "apple_failed": "Login Apple non riuscito",
    "contract_docx": "Scarica il contratto integrale (DOCX)",
    "costs_title": "Quanto ti costa Hostaly",
    "costs_body": "Nessun costo di iscrizione. La commissione si applica a ogni prenotazione, e scende con il piano.",
    "to_staff": "Ti hanno assegnato un ruolo in una struttura? Crea l'account qui",
    "host_plans": "Piani per host",
    "pick_plan": "Scegli il piano che ti serve"
  },
  "dash": {
    "welcome": "Benvenuta,",
    "overview": "Panoramica",
    "property": "Struttura",
    "rooms": "Camere",
    "bookings": "Prenotazioni",
    "marketplace": "Rete",
    "groups": "Richieste gruppo",
    "reviews": "Valutazioni",
    "ical": "OTA Sync",
    "swaps": "Scambi",
    "breakfast": "Colazione",
    "total_bookings": "Prenotazioni totali",
    "revenue": "Ricavi",
    "open_offers": "Offerte aperte",
    "published": "Pubblicata",
    "not_published": "Non pubblicata",
    "publish": "Pubblica vetrina",
    "unpublish": "Nascondi vetrina",
    "view_showcase": "Vedi vetrina pubblica",
    "copy_link": "Copia link",
    "copied": "Copiato!",
    "save": "Salva modifiche",
    "saved": "Salvato",
    "name": "Nome",
    "city": "Città",
    "region": "Regione",
    "address": "Indirizzo",
    "country": "Paese",
    "country_help": "Dove si trova l'immobile: da qui vengono gli identificativi e le scadenze che ti mostriamo.",
    "locality": "Comune / località",
    "currency": "Valuta",
    "currency_help": "La valuta del paese. I prezzi delle camere e gli addebiti sono ancora in euro: il sito converte solo per la visualizzazione.",
    "obligations_title": "Adempimenti del paese",
    "obligations_hint": "Cosa va comunicato, a chi ed entro quando. L'elenco è quello del paese della struttura: cambiando paese cambiano gli adempimenti.",
    "obligations_active": "Attivo",
    "obligations_toggle": "Segna come attivo",
    "obligations_source": "Fonte ufficiale",
    "obligations_verified": "Verificato il",
    "obligations_error": "Non riesco a salvare l'adempimento",
    "timezone": "Fuso orario",
    "phone": "Telefono",
    "desc_it": "Descrizione (IT)",
    "desc_en": "Descrizione (EN)",
    "amenities": "Servizi (separati da virgola)",
    "hero_image": "Foto principale",
    "photos": "Galleria foto",
    "property_type": "Tipo struttura",
    "add_room": "Aggiungi camera",
    "room_name": "Nome camera",
    "price_night": "Prezzo/notte (€)",
    "capacity": "Capacità",
    "photo_url": "URL foto",
    "publish_offer": "Metti in rete",
    "no_bookings": "Nessuna prenotazione ancora",
    "no_rooms": "Nessuna camera. Aggiungine una per iniziare.",
    "offer_from": "Da",
    "offer_to": "A",
    "post_group_req": "Pubblica richiesta gruppo",
    "title": "Titolo",
    "guests": "Ospiti",
    "budget": "Budget/notte (€)",
    "notes_it": "Note (IT)",
    "notes_en": "Note (EN)",
    "respond": "Rispondi",
    "rooms_offered": "Camere offerte",
    "message": "Messaggio",
    "send": "Invia risposta",
    "responses": "risposte",
    "total": "Totale",
    "night": "notte",
    "nights": "notti",
    "upload_photo": "Carica foto",
    "uploading": "Caricamento...",
    "drop_here": "Trascina o clicca per caricare",
    "remove": "Rimuovi",
    "ical_title": "Sincronizza OTA via iCal",
    "ical_sub": "Importa disponibilità e prenotazioni da Booking, Airbnb, Expedia, Vrbo.",
    "ical_url": "URL iCal",
    "ical_source": "Piattaforma",
    "ical_import": "Importa",
    "ical_last_sync": "Ultima sync",
    "ical_events": "Eventi importati",
    "calendar_unified": "Calendario unificato",
    "swap_forward": "Inoltra a partner",
    "swap_title": "Scambio camera",
    "partner_property": "Struttura partner",
    "partner_room": "Camera partner",
    "commission_10": "Commissione 10% verrà trattenuta",
    "swap_notes": "Note per il partner",
    "swap_send": "Proponi scambio",
    "no_swaps": "Nessuno scambio ancora",
    "breakfast_title": "Colazione centralizzata",
    "breakfast_sub": "Offri o prenota colazioni per i tuoi ospiti in rete.",
    "add_breakfast_slot": "Nuovo turno colazione",
    "slot_date": "Data",
    "slot_time": "Ora",
    "slot_max": "Coperti massimi",
    "slot_price": "Prezzo/coperto (€)",
    "book_covers": "Prenota coperti",
    "covers": "coperti",
    "book_slot": "Prenota",
    "available": "disponibili",
    "your_breakfast_bookings": "Le tue prenotazioni colazione",
    "role": "Ruolo",
    "date": "Data",
    "amount": "Importo",
    "source": "Origine",
    "event_title": "Titolo",
    "start": "Inizio",
    "end": "Fine",
    "no_events": "Nessun evento — importa un iCal o ricevi una prenotazione.",
    "welcome_back": "Bentornata",
    "toast_uploaded": "Caricato",
    "toast_upload_failed": "Caricamento fallito",
    "toast_error": "Errore",
    "toast_swap_sent": "Scambio proposto · ospite avvisato",
    "toast_slot_added": "Turno aggiunto",
    "toast_slot_booked": "Prenotato",
    "toast_offer_posted": "Offerta pubblicata",
    "toast_gr_posted": "Richiesta pubblicata",
    "toast_response_sent": "Risposta inviata",
    "toast_imported": "Importati {n} eventi",
    "select_room": "Seleziona camera",
    "select_partner": "Seleziona partner",
    "select_booking": "Seleziona prenotazione",
    "no_paid_bookings": "Nessuna prenotazione pagata",
    "per_cover": "per coperto",
    "outgoing": "in uscita",
    "incoming": "in arrivo",
    "from_label": "Da:",
    "to_label": "A:",
    "commission_10pct": "Commissione (10%)",
    "analytics": "Analytics",
    "revenue_monthly": "Ricavi mensili",
    "direct_bookings": "Prenotazioni dirette",
    "swap_commissions": "Commissioni scambi",
    "breakfast_income": "Ricavi colazione",
    "no_analytics": "Ancora nessun dato — inizia a ricevere prenotazioni.",
    "stripe_connect": "Payouts automatici",
    "connect_start": "Attiva Stripe Connect",
    "connect_continue": "Completa onboarding",
    "connect_done": "Payouts attivi",
    "connect_pending": "Onboarding in corso",
    "connect_hint": "Ricevi automaticamente le prenotazioni dirette al netto della commissione Hostaly (8% Base · 6% Pro · 4,5% Enterprise). Costi Stripe gestione pagamenti a carico del conto collegato.",
    "accept_split": "Accetta e ripartisci",
    "select_partners": "Seleziona partner",
    "allocated_rooms": "Camere assegnate",
    "allocation_confirmed": "Ripartizione confermata",
    "push_title": "Notifiche browser",
    "push_hint": "Ricevi un avviso sul dispositivo anche quando la scheda è chiusa.",
    "push_enable": "Attiva notifiche",
    "push_disable": "Disattiva",
    "push_on": "Attive",
    "push_off": "Spente",
    "push_denied": "Bloccate dal browser",
    "instagram": "Instagram",
    "ig_handle": "Handle Instagram (@)",
    "ig_posts": "Post recenti",
    "ig_add": "Aggiungi post",
    "ig_image": "URL immagine",
    "ig_caption": "Didascalia",
    "ig_link": "Link post",
    "verification": "Verifica",
    "verify_title": "Verifica struttura",
    "verify_hint": "Le strutture verificate compaiono con il bollino ✓ sul marketplace e sulla vetrina.",
    "verified": "Verificata",
    "pending_verify": "In attesa",
    "not_verified": "Non verificata",
    "submit_verify": "Richiedi verifica",
    "vat_number": "Partita IVA (11 cifre)",
    "business_name": "Ragione sociale",
    "municipality": "Comune",
    "declaration": "Dichiaro sotto la mia responsabilità che questi dati sono corretti",
    "admin": "Amministrazione",
    "admin_pending": "Richieste in attesa",
    "approve": "Approva",
    "reject": "Respingi",
    "admin_note": "Nota interna",
    "ai_copy": "Genera con AI",
    "ai_copy_title": "Genera vetrina con AI",
    "ai_copy_hint": "Inserisci qualche parola chiave — l'AI creerà descrizione IT/EN e servizi.",
    "ai_keywords": "Parole chiave (separate da virgola)",
    "ai_tone": "Tono",
    "ai_generate": "Genera",
    "ai_apply": "Applica alla vetrina",
    "promo_code": "Codice sconto",
    "promo_apply": "Applica",
    "promo_valid": "Codice valido",
    "promo_saved": "Risparmi",
    "trade_nav": "Trade B2B",
    "trade_title": "Vendita B2B per tour operator e agenzie",
    "trade_sub": "Compra blocchi di camere direttamente dalle strutture italiane a tariffe riservate.",
    "trade_offers": "Offerte trade",
    "trade_login": "Accedi trade",
    "trade_register": "Registra agenzia",
    "trade_company": "Nome agenzia / tour operator",
    "trade_vat": "Partita IVA",
    "trade_country": "Paese",
    "trade_publish": "Pubblica offerta trade",
    "trade_new_offer": "Nuova offerta trade",
    "trade_rooms_available": "Camere disponibili",
    "trade_price_per_night": "Prezzo/camera/notte (€)",
    "trade_min_nights": "Notti minime",
    "trade_buy": "Compra ora",
    "trade_orders_mine": "Le mie prenotazioni",
    "trade_sold": "vendute",
    "trade_tab": "Trade",
    "partner_center_tab": "Partner Center",
    "channels_tab": "Canali OTA",
    "b2b_title": "Canale B2B · bedbank",
    "b2b_subtitle": "Compra tariffe nette da un bedbank, applica il tuo ricarico e ribalta la provvigione al partner.",
    "b2b_suppliers": "Fornitori",
    "b2b_add_supplier": "Aggiungi fornitore",
    "b2b_mapping": "Mapping hotel",
    "b2b_rules": "Regole di prezzo",
    "b2b_simulator": "Simulatore",
    "b2b_settlements": "Liquidazioni",
    "b2b_net": "Tariffa netta",
    "b2b_nights": "Notti",
    "b2b_markup": "Ricarico",
    "b2b_rebate": "Ribaltamento",
    "b2b_msp": "Prezzo minimo (MSP)",
    "b2b_gross": "Prezzo al pubblico",
    "b2b_charged": "Incassato subito",
    "b2b_margin": "Margine",
    "b2b_blocked": "Non vendibile",
    "b2b_msp_binding": "Prezzo bloccato dal minimo del fornitore",
    "b2b_cashback": "Il ribaltamento arriva dopo la prenotazione",
    "b2b_needed_markup": "Ricarico necessario",
    "b2b_target_margin": "Margine obiettivo",
    "b2b_credentials_missing": "Credenziali mancanti",
    "b2b_confirmed_by": "Confermato da",
    "b2b_auto": "Collegato automaticamente",
    "b2b_review": "Da confermare",
    "b2b_no_candidates": "Nessun candidato compatibile",
    "b2b_partners": "Controparti",
    "b2b_add_partner": "Aggiungi controparte",
    "b2b_partner_kind": "Tipo",
    "b2b_partner_agency": "Agenzia",
    "b2b_partner_tour_operator": "Tour operator",
    "b2b_partner_hotel": "Altro hotel",
    "b2b_partner_vat": "Partita IVA",
    "b2b_payment_terms": "Termini di pagamento",
    "b2b_credit_risk": "Rischio insoluto",
    "b2b_credit_limit": "Fido",
    "b2b_terms_agency": "Agenzie e altri hotel: nessun incasso da consumatori, quindi niente checkout con carta.",
    "b2b_outstanding": "Da saldare",
    "b2b_rates": "Tariffario per controparte",
    "b2b_net_rate": "Tariffa netta",
    "b2b_public_price": "Prezzo di vetrina",
    "b2b_above_public": "Sopra il prezzo di vetrina",
    "b2b_above_public_hint": "Stai chiedendo alla controparte più di quanto chiedi a un ospite che arriva dalla vetrina. L'agenzia lo nota e ti bypassa."
  },
  "vetrina": {
    "book": "Prenota",
    "from": "da",
    "per_night": "/ notte",
    "rooms": "Camere",
    "reviews": "Recensioni",
    "contact": "Contatti",
    "leave_review": "Lascia una recensione",
    "guest_name": "Il tuo nome",
    "rating": "Valutazione",
    "comment": "Il tuo commento",
    "submit": "Invia recensione",
    "services": "Servizi",
    "check_in": "Check-in",
    "check_out": "Check-out",
    "guest_email": "La tua email",
    "confirm_book": "Conferma e paga",
    "total_price": "Totale",
    "processing": "Elaborazione...",
    "book_this_room": "Prenota questa camera",
    "promo_code": "Codice sconto",
    "promo_apply": "Applica",
    "promo_valid": "Codice valido",
    "promo_saved": "Risparmi",
    "traveller_nudge": "Sei un viaggiatore?",
    "prefill_login": "Accedi per precompilare i tuoi dati →",
    "beds": "Posti letto",
    "beds_hint": "Prezzo per letto: {count} posti disponibili in questa camerata.",
    "phone": "Telefono",
    "phone_optional": "Telefono (opzionale)",
    "phone_placeholder": "+39 333 123 4567",
    "phone_hint": "L'host lo userà solo per contatti relativi a questa prenotazione.",
    "charged_in": "Addebito in {currency} · {amount}",
    "fx_note": "Cambio BCE 1 EUR = {rate} {currency} ({date})",
    "fx_stale": "ultimo cambio disponibile",
    "pay_now": "Paga ora",
    "pay_now_hint": "Carta · addebito immediato",
    "pay_at_property": "Paga in struttura",
    "pay_at_property_hint": "Carta a garanzia · addebito solo se no-show",
    "pay_at_hotel": "Paga in hotel",
    "pay_at_hotel_hint": "Paghi tutto al check-in · serve una carta a garanzia",
    "pay_at_hotel_title": "Paghi tutto al check-in, in struttura",
    "pay_at_hotel_step1": "Nessun addebito adesso: il totale del soggiorno lo saldi al check-in, direttamente alla struttura.",
    "pay_at_hotel_step2": "Serve una carta di credito valida per garantire la prenotazione. Non viene addebitata oggi: la conserviamo solo come garanzia.",
    "pay_at_hotel_step3": "La carta viene addebitata solo in caso di no-show o di cancellazione fuori termine, secondo la politica della struttura.",
    "pay_at_hotel_total": "Totale da pagare in struttura",
    "pay_at_hotel_continue": "Continua con la carta a garanzia",
    "pay_at_hotel_unavailable": "La carta a garanzia non è disponibile in questo momento: prenota con il pagamento con carta oppure contatta la struttura.",
    "paypal_hint": "Paga con il tuo conto PayPal",
    "pay_with_paypal": "Paga con PayPal",
    "paypal_note": "Verrai reindirizzato a PayPal per completare il pagamento in sicurezza, poi torni qui.",
    "redirecting": "Reindirizzamento…",
    "enter_email_code": "Inserisci email e codice",
    "invalid_code": "Codice non valido",
    "phone_invalid": "Inserisci un numero di telefono valido",
    "name_email_required": "Nome ed email obbligatori",
    "pick_dates": "Seleziona le date",
    "accept_policy": "Devi accettare la politica no-show per continuare",
    "report_content": "Segnala un contenuto",
    "guest_terms": "Condizioni di prenotazione",
    "free_cancel": "Cancellazione gratuita",
    "no_show_policy": "Politica no-show",
    "penalty": "Penale",
    "free_cancel_note": "Puoi cancellare gratuitamente fino a {days} giorni prima del check-in.",
    "free_cancel_note_one": "Puoi cancellare gratuitamente fino a 1 giorno prima del check-in.",
    "by_date": "Entro il {date}.",
    "then_retained": "Dopo, viene trattenuto il {percent}%.",
    "penalty_note": "Cancellazione soggetta a penale: {penalty}.",
    "first_night": "prima notte",
    "percent_of_total": "{percent}% del totale",
    "guarantee_card": "Carta a garanzia",
    "no_charge_note": "Non verrà effettuato alcun addebito ora. Faremo solo una verifica temporanea di 1€ (rilasciata subito) per validare la carta.",
    "no_show_consent": "Accetto che, in caso di no-show dopo la scadenza, venga addebitato l'importo di {amount} sulla carta indicata.",
    "confirm_no_charge": "Conferma prenotazione (senza addebito)",
    "please_wait": "Attendere…",
    "booking_confirmed": "Prenotazione confermata · Carta •••• {last4} salvata a garanzia",
    "verified": "Verificata",
    "guest_favourite": "Ospiti Preferiti",
    "guest_favourite_hint": "Ospiti Preferiti — badge assegnato alle strutture più apprezzate",
    "rates_loading": "Tassi in caricamento...",
    "per_bed_night": "per letto / notte",
    "dorm_badge": "Dormitorio {gender} · {beds} letti",
    "floor": "Piano {number}",
    "free_cancel_badge": "Cancellazione gratuita fino a {days} giorni prima",
    "guest": "Ospite",
    "thanks": "Grazie!",
    "posting_as": "Pubblicherai come",
    "rating_5": "Perfetto",
    "rating_4": "Buono",
    "rating_3": "Discreto",
    "rating_2": "Insufficiente",
    "rating_1": "Pessimo",
    "dictate_review": "Detta la recensione",
    "gender_mixed": "misto",
    "gender_female": "femminile",
    "gender_male": "maschile"
  },
  "guest": {
    "my_bookings": "Le mie prenotazioni",
    "my_maps": "Le mie mappe",
    "travellers_area": "Area viaggiatori",
    "have_account": "Hai già un account?",
    "login": "Accedi",
    "signup": "Registrati"
  },
  "pay": {
    "success": "Prenotazione confermata",
    "success_body": "Riceverai una email di conferma. Grazie!",
    "cancel": "Pagamento annullato",
    "cancel_body": "Nessun addebito è stato effettuato.",
    "back_home": "Torna alla home",
    "checking": "Verifica pagamento in corso..."
  },
  "common": {
    "close": "Chiudi",
    "cancel": "Annulla",
    "loading": "Caricamento...",
    "city": "Città",
    "filter_city": "Filtra per città"
  },
  "trip_group": {
    "propose_title": "Altri ospiti nelle tue date",
    "propose_caption": "C'è un gruppo di viaggiatori per {from} → {until}. Puoi aggregarti, anche solo per chiacchierare: nessun obbligo di muoversi insieme.",
    "joined_title": "Sei nel gruppo",
    "joined_caption": "La chat del gruppo è aperta durante le date in comune.",
    "join": "Aggregati",
    "more": "Come funziona",
    "consent_note": "Aggregandoti attivi il consenso ai gruppi di viaggiatori. È generico e revocabile: nessun obbligo di viaggiare insieme.",
    "consent_enable": "Attiva partecipazione",
    "optin_badge": "Viaggiatori singoli",
    "optin_title": "Viaggi da solo? C'è chi fa le tue stesse esperienze.",
    "optin_caption": "Nelle tue date qualcuno visita, mangia e cammina dove andrai tu: puoi unirti al gruppo e stare insieme solo per quello che ti va.",
    "optin_body": "L'adesione si conferma solo al momento del viaggio e si toglie quando vuoi, senza conseguenze sulla prenotazione.",
    "optin_on": "Adesione attiva",
    "optin_off": "Non aderisco",
    "optin_saved": "Preferenza salvata. Puoi cambiarla quando vuoi.",
    "optin_login": "Accedi come viaggiatore per attivarla",
    "optin_error": "Non riesco a salvare la preferenza.",
    "login_required": "Accedi per aggregarti al gruppo.",
    "join_failed": "Non riesco ad aggiungerti al gruppo.",
    "cap_reached": "Sei già in 2 gruppi sovrapposti: esci da uno per entrare in questo.",
    "tooltip_title": "Gruppi di viaggiatori",
    "tooltip_1": "Ci si aggrega per luogo e periodo: basta un solo giorno di soggiorno in comune.",
    "tooltip_2": "Puoi stare in più gruppi, ma al massimo due si sovrappongono nelle stesse date.",
    "tooltip_3": "La chat è aperta solo durante le date in comune: i messaggi fuori da quelle date non arrivano.",
    "tooltip_4": "Gli altri membri vedono solo un nome breve, mai i dettagli della tua prenotazione.",
    "tooltip_5": "Se cancelli la prenotazione esci dal gruppo; se resti l'unico, il gruppo si chiude.",
    "tooltip_window": "Periodo",
    "loading": "Caricamento...",
    "back": "Indietro",
    "chat_title": "Chat del gruppo",
    "chat_hint": "Vedono questi messaggi solo i membri con date in comune. Nessun dettaglio di prenotazione viene condiviso.",
    "chat_failed": "Non riesco a caricare la chat.",
    "send_failed": "Messaggio non inviato.",
    "chat_empty": "Scrivi un messaggio.",
    "no_access": "Nessun accesso",
    "no_access_detail": "La chat è riservata ai membri con un soggiorno in comune ed è aperta solo durante le date condivise.",
    "no_access_after_consent": "Il consenso è attivo, ma non fai parte di questo gruppo: le date non coincidono più, oppure il gruppo si è chiuso.",
    "not_found": "Gruppo non trovato",
    "no_messages": "Nessun messaggio ancora. Rompi il ghiaccio.",
    "new_message": "Nuovo messaggio",
    "message_placeholder": "Scrivi qualcosa al gruppo...",
    "send": "Invia",
    "cancel": "Annulla",
    "announce": "Avviso",
    "announcement": "Avviso",
    "meeting": "Incontro",
    "meeting_proposal": "Proposta di incontro",
    "new_meeting": "Proponi un incontro",
    "meeting_when": "Quando",
    "meeting_when_placeholder": "es. sabato mattina",
    "meeting_when_required": "Indica quando.",
    "meeting_where": "Dove",
    "meeting_where_placeholder": "es. ingresso del museo",
    "meeting_where_required": "Indica dove.",
    "meeting_note": "Nota (facoltativa)",
    "meeting_note_placeholder": "Qualcosa da aggiungere?",
    "propose": "Proponi",
    "members": "Membri",
    "member_count": "Membri: {n}",
    "no_members": "Ancora nessun membro.",
    "anonymous": "Ospite",
    "chat_ok": "In chat",
    "chat_no": "Solo gruppo"
  }
};
